import { useCallback, useState } from 'react'

import { findSimilarCards, type SimilarCard } from '@/api/services/related'

export type SimilarCardsGate = {
  /** 似ているカード（まだ確かめていなければ null） */
  similar: SimilarCard[] | null
  /** つなぐことにしたカードの id */
  linkIds: number[]
  toggleLink: (memoId: number) => void
  /**
   * カードを作る前に似たカードを確かめる。似たカードが見つかったら false（知らせて止まる）を返す。
   * 一度知らせたあとは true を返すので、もう一度押せばそのまま作れる。確かめられなかったときも止めない
   */
  check: (text: string) => Promise<boolean>
  isChecking: boolean
}

/** カードを作る前に、似ているカードがあれば知らせる（保存は止めず、つなぐかを選べる） */
export const useSimilarCardsGate = (): SimilarCardsGate => {
  const [similar, setSimilar] = useState<SimilarCard[] | null>(null)
  const [linkIds, setLinkIds] = useState<number[]>([])
  const [isChecking, setIsChecking] = useState(false)

  const toggleLink = useCallback(
    (memoId: number) =>
      setLinkIds((prev) => (prev.includes(memoId) ? prev.filter((id) => id !== memoId) : [...prev, memoId])),
    [],
  )

  const check = useCallback(
    async (text: string) => {
      if (similar !== null) return true
      setIsChecking(true)
      try {
        const items = await findSimilarCards(text)
        setSimilar(items)
        return items.length === 0
      } catch (error) {
        console.error('似ているカードを確かめられませんでした:', error)
        setSimilar([])
        return true
      } finally {
        setIsChecking(false)
      }
    },
    [similar],
  )

  return { similar, linkIds, toggleLink, check, isChecking }
}
